module.exports = __webpack_public_path__ + "static/img/12377.8da78c3b.png";